/**
 * @fileOverview
 * 移动光标到上一个/下一个块
 *
 * @see https://github.com/draft-js-plugins/draft-js-plugins/blob/master/draft-js-focus-plugin/src/modifiers/setSelection.js
 */

import { SelectionState, EditorState } from 'draft-js';
import DraftOffsetKey from 'draft-js/lib/DraftOffsetKey';
import { setSelectionToBlock } from 'lib/helpers';

/**
 * Set selection of editor to next/previous block
 *
 * @param {DraftEditorStore} store
 * @param {"next"|"prev"} direction
 * @param {React.KeyboardEvent} evt
 */
export function setSelectionToSibling(store, direction, evt) {
	const { getEditorState, setEditorState } = store;
	const editorState = getEditorState();
	const selectionKey = editorState.getSelection().getAnchorKey();
	const newActiveBlock = direction === 'prev'
		? editorState.getCurrentContent().getBlockBefore(selectionKey)
		: editorState.getCurrentContent().getBlockAfter(selectionKey);

	if (newActiveBlock && newActiveBlock.get('key') === selectionKey) {
		return false;
	}

	if (newActiveBlock) {
		setSelectionToBlock(store, newActiveBlock, direction === 'prev' ? 'expand' : 'collapse');
		evt.preventDefault();
		return true;
	}
	return false;
};



// WEBPACK FOOTER //
// ./lib/helpers/setSelectionToSibling.js